import React from 'react';

interface SelectCircleIconProps {
  checked?: boolean;
  size?: number;
  className?: string;
}

// Shared across instances. Every instance defines an identical gradient, so a
// single static id resolves correctly even when many cards render at once.
const GOLD_GRADIENT_ID = 'egmSelectCircleGold';

export const SelectCircleIcon: React.FC<SelectCircleIconProps> = ({
  checked = false,
  size = 24,
  className,
}) =>
  checked ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient
          id={GOLD_GRADIENT_ID}
          x1="3.5"
          y1="3.5"
          x2="20.5"
          y2="20.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8DE95" />
          <stop offset="0.5" stopColor="#E4A83F" />
          <stop offset="1" stopColor="#CE8E1E" />
        </linearGradient>
      </defs>
      {/* Gold disc with the checkmark punched out (even-odd) so the card
          background shows through the check, matching the design. */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9998 2.16772C17.4264 2.16772 21.8321 6.57342 21.8321 12C21.8321 17.4266 17.4264 21.8323 11.9998 21.8323C6.57318 21.8323 2.16748 17.4266 2.16748 12C2.16748 6.57342 6.57318 2.16772 11.9998 2.16772ZM5.30088 13.3673C7.67298 15.6071 8.18293 18.2173 8.18293 18.2173L9.95523 16.9347C11.5554 11.8224 17.7412 6.54412 17.7412 6.54412L17.5611 5.78277C10.8038 10.7397 9.04288 15.1115 9.04288 15.1115C8.30233 13.0812 7.01878 12.0206 7.01878 12.0206L5.30088 13.3673Z"
        fill={`url(#${GOLD_GRADIENT_ID})`}
      />
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <circle cx="12.0248" cy="12" r="9.35" stroke="white" />
    </svg>
  );

export default SelectCircleIcon;
